import React, { useState } from 'react';
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Paper,
  Modal,
  Stepper,
  Step,
  StepLabel,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  CircularProgress,
  Alert,
  Collapse,
  IconButton,
  styled
} from '@mui/material';
import {
  Event as EventIcon,
  Close as CloseIcon,
  Add as AddIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';

const StyledModal = styled(Modal)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const ModalContent = styled(Paper)(({ theme }) => ({
  backgroundColor: '#1a1a1a',
  padding: theme.spacing(4),
  borderRadius: theme.spacing(2),
  width: '80%',
  maxWidth: '900px',
  maxHeight: '90vh',
  overflow: 'auto',
  position: 'relative',
  border: '1px solid rgba(255, 255, 255, 0.12)',
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    color: '#fff',
    '& fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.23)',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.5)',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#00BCD4',
    },
  },
  '& .MuiInputLabel-root': {
    color: 'rgba(255, 255, 255, 0.7)',
    '&.Mui-focused': {
      color: '#00BCD4',
    },
  },
}));

const StyledStepper = styled(Stepper)(({ theme }) => ({
  '& .MuiStepLabel-label': {
    color: 'rgba(255, 255, 255, 0.7)',
    '&.Mui-active': {
      color: '#00BCD4',
    },
    '&.Mui-completed': {
      color: '#4CAF50',
    },
  },
  '& .MuiStepIcon-root': {
    color: 'rgba(255, 255, 255, 0.3)',
    '&.Mui-active': {
      color: '#00BCD4',
    },
    '&.Mui-completed': {
      color: '#4CAF50',
    },
  },
}));

const FundProgramForm = ({ openModal, handleCloseModal, onSubmit }) => {
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [eventData, setEventData] = useState({
    eventName: '',
    eventType: '',
    eventSubType: '',
    startDate: '',
    endDate: '',
    targetAudience: '',
    location: '',
    permitsRequired: '',
    estimatedAttendees: '',
    estimatedBudget: '',
    fundingSource: '',
    alcoholPolicyRequired: false,
    eventInsuranceRequired: false,
    alcoholInsuranceRequired: false,
    fmvItems: [],
    complianceChecklist: '',
    notes: '',
    leaderboardVisibility: 'private',
    donationPageCustomization: {
      backgroundColor: '#ffffff',
      primaryTextColor: '#333333',
      highlightColor: '#00BCD4',
      buttonBackgroundColor: '#00BCD4',
      buttonTextColor: '#ffffff',
      logo: null,
      customizableSections: []
    },
    donationItems: [],
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [newFmvItem, setNewFmvItem] = useState({ description: '', fmv: '' });
  const [newDonationItem, setNewDonationItem] = useState({ title: '', description: '', price: 0 });

  const steps = [
    'Event Basics',
    'Fundraising & FMV',
    'Compliance',
    'Donation Page',
    'Add Donation Items',
    'Customize Sections'
  ];

  return (
    <>
      <StyledModal open={openModal} onClose={handleCloseModal}>
        <ModalContent>
          <Box sx={{ position: 'relative' }}>
            <IconButton
              onClick={handleCloseModal}
              sx={{ position: 'absolute', top: 10, right: 10 }}
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h5" gutterBottom>
              {steps[step]}
            </Typography>
            <StyledStepper activeStep={step}>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </StyledStepper>
          </Box>
          <Box sx={{ mt: 2 }}>
            {/* Step content */}
          </Box>
          <Box sx={{ mt: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="contained"
                  type="submit"
                  disabled={loading}
                  sx={{
                    backgroundColor: '#00BCD4',
                    '&:hover': {
                      backgroundColor: '#00ACC1',
                    },
                    '&:disabled': {
                      backgroundColor: 'rgba(0, 188, 212, 0.5)',
                    }
                  }}
                >
                  {loading ? (
                    <CircularProgress size={24} sx={{ color: '#fff' }} />
                  ) : (
                    'Submit Program'
                  )}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </ModalContent>
      </StyledModal>
    </>
  );
};

export default FundProgramForm; 